import React from 'react';
import { Minus, Plus } from 'lucide-react';
import Tooltip from '../Tooltip';

const DimensionsSelector = ({
  largeur,
  setLargeur,
  projection,
  setProjection,
  projection2,
  setProjection2,
  hauteurLambrequin,
  setHauteurLambrequin,
  isDoublePente,
  isLambrequinSeul,
  isBriseVue,
  fabricCalculation
}) => {
  return (
    <div className="p-6 border-2 border-celadon rounded-lg">
      <h3 className="text-lg font-bold mb-4 flex items-center gap-2">
        Dimensions sur-mesure
        <Tooltip tooltipKey="dimensions-sur-mesure" size={16} />
      </h3>
      
      {/* Largeur */}
      <div className="mb-4">
        <label className="block text-sm font-medium mb-2">Largeur (cm)</label>
        <div className="flex items-center gap-3">
          <button
            onClick={() => setLargeur(Math.max(100, largeur - 10))}
            className="p-2 border border-gray-300 rounded hover:bg-gray-100 transition-colors"
          >
            <Minus size={16} />
          </button>
          <input
            type="number"
            value={largeur}
            onChange={(e) => setLargeur(Number(e.target.value))}
            className="flex-1 px-4 py-2 border border-gray-300 rounded text-center font-medium focus:outline-none focus:border-celadon"
            min="100"
            max="2000"
          />
          <button
            onClick={() => setLargeur(Math.min(2000, largeur + 10))}
            className="p-2 border border-gray-300 rounded hover:bg-gray-100 transition-colors"
          >
            <Plus size={16} />
          </button>
        </div>
      </div>

      {/* Pour lambrequin seul : uniquement hauteur du lambrequin */}
      {isLambrequinSeul ? (
        <div className="mb-4">
          <label className="block text-sm font-medium mb-2">Hauteur du lambrequin (cm)</label>
          <div className="flex items-center gap-3">
            <button
              onClick={() => setHauteurLambrequin(Math.max(15, hauteurLambrequin - 5))}
              className="p-2 border border-gray-300 rounded hover:bg-gray-100 transition-colors"
            >
              <Minus size={16} />
            </button>
            <input
              type="number"
              value={hauteurLambrequin}
              onChange={(e) => setHauteurLambrequin(Number(e.target.value))}
              className="flex-1 px-4 py-2 border border-gray-300 rounded text-center font-medium focus:outline-none focus:border-celadon"
              min="15"
              max="100"
            />
            <button
              onClick={() => setHauteurLambrequin(Math.min(100, hauteurLambrequin + 5))}
              className="p-2 border border-gray-300 rounded hover:bg-gray-100 transition-colors"
            >
              <Plus size={16} />
            </button>
          </div>
        </div>
      ) : !isDoublePente ? (
        <div className="mb-4">
          <label className="block text-sm font-medium mb-2">Avancée (cm)</label>
          <div className="flex items-center gap-3">
            <button
              onClick={() => setProjection(Math.max(80, projection - 10))}
              className="p-2 border border-gray-300 rounded hover:bg-gray-100 transition-colors"
            >
              <Minus size={16} />
            </button>
            <input
              type="number"
              value={projection}
              onChange={(e) => setProjection(Number(e.target.value))}
              className="flex-1 px-4 py-2 border border-gray-300 rounded text-center font-medium focus:outline-none focus:border-celadon"
              min="80"
              max="2000"
            />
            <button
              onClick={() => setProjection(Math.min(2000, projection + 10))}
              className="p-2 border border-gray-300 rounded hover:bg-gray-100 transition-colors"
            >
              <Plus size={16} />
            </button>
          </div>
        </div>
      ) : (
        <>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">Avancée 1 (cm)</label>
            <div className="flex items-center gap-3">
              <button
                onClick={() => setProjection(Math.max(80, projection - 10))}
                className="p-2 border border-gray-300 rounded hover:bg-gray-100 transition-colors"
              >
                <Minus size={16} />
              </button>
              <input
                type="number"
                value={projection}
                onChange={(e) => setProjection(Number(e.target.value))}
                className="flex-1 px-4 py-2 border border-gray-300 rounded text-center font-medium focus:outline-none focus:border-celadon"
                min="80"
                max="2000"
              />
              <button
                onClick={() => setProjection(Math.min(2000, projection + 10))}
                className="p-2 border border-gray-300 rounded hover:bg-gray-100 transition-colors"
              >
                <Plus size={16} />
              </button>
            </div>
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">Avancée 2 (cm)</label>
            <div className="flex items-center gap-3">
              <button
                onClick={() => setProjection2(Math.max(80, projection2 - 10))}
                className="p-2 border border-gray-300 rounded hover:bg-gray-100 transition-colors"
              >
                <Minus size={16} />
              </button>
              <input
                type="number"
                value={projection2}
                onChange={(e) => setProjection2(Number(e.target.value))}
                className="flex-1 px-4 py-2 border border-gray-300 rounded text-center font-medium focus:outline-none focus:border-celadon"
                min="80"
                max="2000"
              />
              <button
                onClick={() => setProjection2(Math.min(2000, projection2 + 10))}
                className="p-2 border border-gray-300 rounded hover:bg-gray-100 transition-colors"
              >
                <Plus size={16} />
              </button>
            </div>
          </div>
        </>
      )}

      {/* Surface totale */}
      <div className="p-4 bg-white rounded border border-gray-200">
        <p className="text-sm text-gray-600">Surface totale :</p>
        <p className="text-2xl font-bold text-gray-900">
          {isLambrequinSeul
            ? ((largeur * hauteurLambrequin) / 10000).toFixed(2)
            : isDoublePente 
              ? ((largeur * (projection + projection2)) / 10000).toFixed(2) 
              : ((largeur * projection) / 10000).toFixed(2)} m²
        </p>
      </div>
    </div>
  );
};

export default DimensionsSelector;